import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import BookingsDrawer from "components/drawer/BookingsDrawer";
import BookingsDrawerCity from "components/drawer/BookingsDrawerCity";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import ViewModal from "components/modal/ViewBookingsModal";
import EditDeleteButton from "components/table/EditDeleteButton";
import EmailInvoiceModal from "components/modal/EmailInvoiceModal";
import EmailItineraryModal from "components/modal/EmailItineraryModal";
import Tooltips from "../tooltip/Tooltip";
import { Modal } from "antd";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Tooltip from "@mui/material/Tooltip";
import useToggleDrawer from "hooks/useToggleDrawer";
import { SidebarContext } from "context/SidebarContext";
import React, { useState, useContext } from "react";
import { FiEdit, FiFile, FiEye, FiDownload } from "react-icons/fi";
import { Button } from "@windmill/react-ui";
import { notifyError, notifySuccess } from "utils/toast";
import ItineraryModal from "components/form/ItineraryModal";
import CancelModal from "components/form/CancelModal";
import Updatearrivalmodal from "components/modal/Updatearrivalmodal";
import CancelOfflineModal from "components/form/CancelOfflineModal";
import Tourexecutemodal from "components/modal/Tourexecutemodal";
import TourDepatureexecutemodal from "components/modal/TourDepatureexecutemodal";
import ClientSmsModal from "components/modal/ClientSmsModal";
import DriverSmsModal from "components/modal/DriverSmsModal";
import BookingServices from "services/BookingServices";
import { FaInfoCircle } from "react-icons/fa";
import ViewFeedbackModal from "components/modal/ViewFeedbackModal";
import ClientEscalationModal from "components/modal/ClientEscalationModal";
import ViewOnTourFeedbackModal from "components/modal/ViewOnTourFeedbackModal";
import ClientFeedbackServices from "services/ClientFeedbackServices";
import BookingUpdatearrivalmodal from "components/modal/BookingVehicleDriverAllotedModelForArrived";

const adminInfo = localStorage.getItem("adminInfo")
  ? JSON.parse(localStorage.getItem("adminInfo"))
  : null;

const accessToken = localStorage.getItem("authkey");

const getEscalationStatus = (escalationArray) => {
  if (!Array.isArray(escalationArray) || escalationArray.length === 0) {
    return null; // no escalation → no icon
  }

  const latest = escalationArray[escalationArray.length - 1];
  return latest?.status; // "ongoing" or "sorted"
};

const getSortedCount = (escalationArray) => {
  if (!Array.isArray(escalationArray) || escalationArray.length === 0) return 0;
  return escalationArray.filter((item) => item.status === "sorted").length;
};

const BookingsTable = ({
  agents,
  perpage,
  currentPage,
  hideEdit,
  showSensitiveColumns,
  hideDelete,
  hideView,
  hideAdd,
  hideExport,
  fetchFeedback,
}) => {
  const { title, serviceId, handleModalOpen, handleView, handleUpdate } =
    useToggleDrawer();
  const { setIsUpdate } = useContext(SidebarContext);
  const [showItineraryModal, setShowItineraryModal] = useState(false);
  const [showUpdatearrivalModal, setshowUpdatearrivalModal] = useState(false);
  const [showTourModal, setshowTourModal] = useState("");
  const [showTourDepartureModal, setshowTourDepartureModal] = useState("");
  const [clientid, setclientid] = useState("");
  const [guestimage, setGuestImage] = useState("");
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showCancelOfflineModal, setShowCancelOfflineModal] = useState(false);
  const [bookingId, setBookingId] = useState("");
  const [itinerary, setItinerary] = useState("");
  const [selectedData, setSelectedData] = useState(null);
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openClientModal, setOpenClientModal] = useState(false);
  const [openDriverModal, setOpenDriverModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const id_employee = adminInfo?.id ? adminInfo.id : 0;
  const isTrans = adminInfo?.id_profile == 2 ? true : false;
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [historyDrivers, setHistoryDrivers] = useState([]);
  const [openDriverHistoryModal, setOpenDriverHistoryModal] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [cancellationExceed, setCancellationExceed] = useState(false);
  const [sellingPrice, setSellingPrice] = useState("");
  const [showViewFeedbackModal, setShowViewFeedbackModal] = useState(false);
  const [escalateModal, SetEscalateModal] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [openView, setOpenView] = useState(false);
  //  const [openVehicleHistoryModal, setOpenVehicleHistoryModal] = useState(false);
  //   const [historyVehicles, setHistoryVehicles] = useState([]);
  // Function to format any date input to yyyy-mm-dd
  // const formatDate = (date) => {
  //   if (!date) return ''; // Handle null or undefined
  //   try {
  //     // Check if already in yyyy-mm-dd format
  //     if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
  //       return date;
  //     }

  //     let parsedDate;
  //     if (typeof date === 'string') {
  //       // Try DD-MM-YYYY (e.g., 28-05-2025)
  //       if (/^\d{2}-\d{2}-\d{4}$/.test(date)) {
  //         const [day, month, year] = date.split('-');
  //         parsedDate = new Date(`${day}-${month}-${year}`);
  //       }
  //       // Try other formats (e.g., ISO)
  //       else {
  //         parsedDate = new Date(date);
  //       }
  //     } else {
  //       // Handle Date objects or other types
  //       parsedDate = new Date(date);
  //     }

  //     // Verify parsed date is valid
  //     if (isNaN(parsedDate.getTime())) {
  //       return '';
  //     }

  //     // Format to yyyy-mm-dd
  //     const year = parsedDate.getFullYear();
  //     const month = String(parsedDate.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  //     const day = String(parsedDate.getDate()).padStart(2, '0');
  //     return `${day}-${month}-${year}`;
  //   } catch (e) {
  //     return ''; // Return empty string on error
  //   }
  // };
  const [actionLabels, setActionLabels] = useState({
    viewLabel: "",
    editLabel: "",
    actionLabel: "", // add this
  });

  const handleCancelBooking = async (reason) => {
    let body = { cancel_reason: reason };
    const res = await BookingServices.cancelBooking(bookingId, body);
    setIsUpdate(true);
    notifySuccess(res.message);
    setShowCancelModal(false);
  };

  const handleCancelOfficeBooking = async (
    reason,
    value,
    cancellationExceed,
    cancellationType,
  ) => {
    try {
      const body = {
        cancel_reason: reason,
        id_employee: id_employee,
        cancellationExceed: cancellationExceed,
      };

      if (cancellationExceed) {
        // This means refund mode — use value as refundable_amount
        body.refundable_amount = value;
      } else {
        // This means cancellation fee mode
        if (cancellationType === "percentage") {
          body.percentage = value;
          body.cancellation_type = "percentage";
        } else if (cancellationType === "value") {
          body.refundable_amount = value;
          body.cancellation_type = "value";
        }
      }

      await BookingServices.cancelOfflineBooking(bookingId, body);
      setIsUpdate(true);
      notifySuccess("Canceled Successfully");
      setShowCancelOfflineModal(false);
      setCancellationExceed(false);
    } catch (error) {
      notifyError("Failed to cancel offline booking. Please try again.");
    }
  };
  const accessToken = localStorage.getItem("authkey");
  const handleDownload = async (invoice_number) => {
    try {
      const url = `${process.env.REACT_APP_API_BASE_URL}/client/invoice/download/${invoice_number}`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${adminInfo.token}`,
          AccessToken: accessToken,
        },
      });
      if (!response.ok) {
        throw new Error("Failed to download file");
      }
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = `invoice_${invoice_number}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      //console.error('Error downloading invoice:', error);
    }
  };
  const handleItineraryDownload = async (client_id, vendor_id) => {
    try {
      setIsDownloading(true);
      toast.info("Downloading itinerary...");

      const url = `${process.env.REACT_APP_API_BASE_URL}/vehicleAllotment/itinerary/${client_id}/${vendor_id}/false`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${adminInfo.token}`,
          AccessToken: accessToken,
        },
      });

      // Check if response is JSON (likely an error or no-record message)
      const contentType = response.headers.get("content-type");

      if (contentType && contentType.includes("application/json")) {
        const json = await response.json();
        if (!json.status) {
          toast.warning(json.message || "No itinerary found.");
          return;
        }
      }

      if (!response.ok) {
        throw new Error("Failed to download itinerary.");
      }

      // Otherwise, handle as blob (PDF download)
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = `itinerary_${client_id}_${vendor_id}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(downloadUrl);

      toast.success("Itinerary downloaded!");
    } catch (error) {
      toast.error("Failed to download itinerary.");
      //console.error('Error downloading itinerary:', error);
    } finally {
      setIsDownloading(false);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedData(null);
    setOpenModal(false);
    setError("");
    setOpenClientModal(false);
    setOpenDriverModal(false);
  };

  const handleSubmit = async (email) => {
    const payload = { email };

    try {
      const response = await BookingServices.emailSend(
        selectedData.client_id,
        payload,
      );

      if (response?.status) {
        notifySuccess(response.message);
        setIsUpdate(true);
      } else {
        notifyError(response.message || "Failed to send the email.");
      }
    } catch (error) {
      //console.error('API Error:', error);
      notifyError(
        error?.response?.data?.message ||
          "An error occurred while sending the email.",
      );
    } finally {
      closeModal();
    }
  };

  const handleSubmitItinerary = async (email) => {
    const payload = { email, is_vendor: true };
    try {
      const response = await BookingServices.itineraryEmailSend(
        selectedData.client_id,
        payload,
      );
      if (response?.status) {
        notifySuccess(response.message);
        setIsUpdate(true);
        closeModal();
      } else {
        closeModal();
        notifyError(response.message);
        setError("Failed to send the email.");
      }
    } catch (error) {
      //console.error('API Error:', error);
      setError("An error occurred while sending the email.");
    }
  };

  const handleSendSms = async (payload) => {
    setIsSubmitting(true);
    try {
      const response = await BookingServices.sendClientSms(
        selectedData.client_id,
        payload,
      );
      if (response?.status) {
        notifySuccess(response.message);
        // setIsUpdate(true);
        closeModal();
      } else {
        notifyError(response?.message);
      }
    } catch (error) {
      notifyError("Error Sending SMS for Client");
      closeModal();
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSendDriverSms = async (payload) => {
    setIsSubmitting(true);
    try {
      const response = await BookingServices.sendDriverSms(
        selectedData.client_id,
        payload,
      );
      if (response?.status) {
        notifySuccess(response.message);
        // setIsUpdate(true);
        closeModal();
      } else {
        notifyError(response?.message);
      }
    } catch (error) {
      //console.error('API Error:', error);
      notifyError("Error Sending SMS for Driver");
      closeModal();
    } finally {
      setIsSubmitting(false);
    }
  };

  const openHistoryModal = async (client_id) => {
    try {
      const res =
        await ClientFeedbackServices.getClientOnTourFeedback(client_id);

      setHistoryData(res?.feedback_history || []);
      setOpenView(true);
    } catch (err) {
      console.error("Error fetching ontour feedback history:", err);
    }
  };
  function getTodayDMY() {
    const d = new Date();
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${day}-${month}-${year}`;
  }

  const today = getTodayDMY();
  const parseDMY = (date) => {
    const [day, month, year] = date.split("-");
    return new Date(year, month - 1, day);
  };

  const todayDate = parseDMY(today);

  return (
    <>
      {hideDelete && <DeleteModal id={serviceId} title={title} />}
      <ViewModal id={serviceId} title={title} data={agents} />
      <MainDrawer>
        {/* <BookingsDrawer id={serviceId} /> */}
          <BookingsDrawerCity id={serviceId} />
      </MainDrawer>

      <EmailInvoiceModal
        isOpen={showModal}
        onClose={closeModal}
        onSubmitClick={handleSubmit}
        data={selectedData}
        error={error}
      />
      <EmailItineraryModal
        isOpen={openModal}
        onClose={closeModal}
        onSubmitClick={handleSubmitItinerary}
        data={selectedData}
        error={error}
      />
      <ClientSmsModal
        isOpen={openClientModal}
        onClose={closeModal}
        handleSubmit={handleSendSms}
        disabled={isSubmitting}
        isSubmitting={isSubmitting}
        error={error}
        contactnumber={selectedData?.contact_no}
      />
      <DriverSmsModal
        isOpen={openDriverModal}
        id={selectedData?.client_id}
        onClose={closeModal}
        handleSubmit={handleSendDriverSms}
        disabled={isSubmitting}
        isSubmitting={isSubmitting}
        error={error}
        contactnumber={selectedData?.driver_no}
      />

      <ViewFeedbackModal
        isOpen={showViewFeedbackModal}
        onClose={() => setShowViewFeedbackModal(false)}
        data={selectedData}
      />

      <ClientEscalationModal
        isOpen={escalateModal}
        onClose={() => {
          SetEscalateModal(false);
        }}
        data={selectedData}
        error={error}
        hideAdd={hideAdd}
        hideEdit={hideEdit}
        hideView={hideView}
        hideExport={hideExport}
      />

      <ViewOnTourFeedbackModal
        isOpen={openView}
        onClose={() => setOpenView(false)}
        feedbackHistory={historyData}
      />

      <TableBody>
        {agents.map((data, index) => {
          const isFeedbackFilled =
            data?.query_driver ||
            data?.query_vehicle ||
            data?.query_depart ||
            data?.query_itinerary ||
            data?.driver_rating ||
            data?.vehicle_rating ||
            (data?.additional_comment &&
              data?.additional_comment.trim() !== "");
          return (
            <TableRow
              key={data.client_id}
              className={data.status === 1 ? "bg-red-100 dark:bg-gray-500" : ""}
            >
              <TableCell>
                <span className="font-semibold uppercase text-xs">
                  {index + 1}
                </span>
              </TableCell>

              <TableCell>
                <div className="text-center">
                  <span className="text-sm">{data["ref_no"]}</span>
                </div>
                <div className="text-center pt-2 text-blue-400">
                  <span className="text-sm">{data["agentref"]}</span>
                </div>
              </TableCell>

              {showSensitiveColumns && (
                <TableCell>
                  <div className="text-center">
                    <Tooltip title={data.agentref} className="text-center ">
                      <span className="text-sm">{data["agentname"]}</span>
                    </Tooltip>
                  </div>
                  <div className="text-center">
                    {" "}
                    <span
                      className={`text-sm ${
                        data.is_online ? "text-green-500" : "text-red-500"
                      }`}
                    >
                      {data.is_online ? "Online" : "Offline"}
                    </span>
                  </div>
                </TableCell>
              )}

              <TableCell>
                <Tooltip
                  title={data.contact_no}
                  className="text-center flex flex-col row-gap-4"
                >
                  <span className="text-sm">{data.client_name}</span>
                  {hideEdit && data.driver_name ? (
                    <span
                      style={{
                        cursor: "pointer",
                        color: "blue",
                        fontSize: "12px",
                      }}
                      className="rounded-md px-3 cursor-pointer"
                      onClick={() => {
                        setSelectedData(data);
                        setOpenClientModal(true);
                      }}
                    >
                      SMS
                    </span>
                  ) : null}
                </Tooltip>
              </TableCell>
              <TableCell className="text-center">
                <span
                  className={`text-sm ${
                    data["package_type"] === "Outstation"
                      ? "text-blue-500"
                      : data["package_type"] === "Hour Rental"
                        ? "text-green-500"
                        : data["package_type"] === "Airport Pickup"
                          ? "text-black-500"
                          : data["package_type"] === "Holiday Package"
                            ? "text-red-500"
                            : "text-gray-500"
                  }`}
                >
                  {data["package_type"]}
                </span>
              </TableCell>
              <TableCell>
                <div className="text-sm flex flex-col row-gap-3">
                  <span>{data.start_date}</span>
                  {data.package_type === "Holiday Package" ||
                  data.package_type === "Outstation" ? (
                    <span>{data.end_date}</span>
                  ) : null}
                </div>
              </TableCell>
              {/* arival and depature */}

              <TableCell className="text-left">
                <div className="text-sm flex flex-col gap-4">
                  {/* Arrival Section */}
                  <div className="flex items-start justify-start gap-2">
                    <span className="text-green-500">A:</span>
                    <span>{data.arrival || "N/A"}</span>
                    {((data.arrival_via &&
                      data.arrival_via !== "Not Selected") ||
                      data.arrival_details ||
                      data.pickup_time) && (
                      <Tooltip
                        title={
                          <div className="text-xs">
                            <strong>Arrival Info:</strong>
                            <p>
                              Via:{" "}
                              {data.arrival_via &&
                              data.arrival_via !== "Not Selected"
                                ? data.arrival_via
                                : "N/A"}
                            </p>
                            <p>Details: {data.arrival_details || "N/A"}</p>
                            <p>Pickup Time: {data.pickup_time || "N/A"}</p>
                          </div>
                        }
                        placement="top"
                        componentsProps={{
                          tooltip: { sx: { fontSize: "12px", padding: "8px" } },
                        }}
                      >
                        <span
                          className="text-blue-500 cursor-pointer"
                          aria-label="View arrival details"
                        >
                          <FaInfoCircle />
                        </span>
                      </Tooltip>
                    )}
                  </div>

                  {/* Departure Section */}
                  <div className="flex items-start justify-start gap-2">
                    <span className="text-red-500">D:</span>
                    <span>{data.departure || "N/A"}</span>
                    {((data.departure_via &&
                      data.departure_via !== "Not Selected") ||
                      data.departure_details) && (
                      <Tooltip
                        title={
                          <div className="text-xs">
                            <strong>Departure Info:</strong>
                            <p>
                              Via:{" "}
                              {data.departure_via &&
                              data.departure_via !== "Not Selected"
                                ? data.departure_via
                                : "N/A"}
                            </p>
                            <p>Details: {data.departure_details || "N/A"}</p>
                          </div>
                        }
                        placement="top"
                        componentsProps={{
                          tooltip: { sx: { fontSize: "12px", padding: "8px" } },
                        }}
                      >
                        <span
                          className="text-blue-500 cursor-pointer"
                          aria-label="View departure details"
                        >
                          <FaInfoCircle />
                        </span>
                      </Tooltip>
                    )}
                  </div>
                </div>
              </TableCell>

              <TableCell className="text-sm text-center">
                <span>{data.booking_date}</span>
              </TableCell>
              {showSensitiveColumns && (
                <TableCell>
                  {data.itinerary ? (
                    <div className="flex flex-col items-center row-gap-4 justify-center">
                      <span
                        onClick={() => {
                          setShowItineraryModal(true);
                          setItinerary(data.itinerary);
                        }}
                        title="Itinerary"
                        className="cursor-pointer text-xl text-green-500"
                      >
                        <FiFile />
                      </span>
                      {data.itinerary && (
                        <span>
                          <Button
                            onClick={() =>
                              handleItineraryDownload(
                                data.client_id,
                                data.vendor_id,
                              )
                            }
                          >
                            <FiDownload />
                          </Button>
                        </span>
                      )}
                      <span
                        onClick={() => {
                          setSelectedData(data);
                          setOpenModal(true);
                        }}
                        className="cursor-pointer text-blue-700 hover:text-blue-500 dark:text-gray-400 dark:hover:text-gray-300 "
                      >
                        Send mail
                      </span>
                    </div>
                  ) : (
                    <div className="flex items-center justify-center h-full">
                      <span className="text-sm text-gray-500 dark:text-gray-400">
                        Itinerary Not Available
                      </span>
                    </div>
                  )}
                </TableCell>
              )}

              <TableCell className="text-center">
                {/* Tooltip for Special Note */}
                <Tooltip
                  title={
                    data.special_note ? (
                      <span
                        dangerouslySetInnerHTML={{ __html: data.special_note }}
                      />
                    ) : null
                  }
                >
                  <span
                    className="text-sm flex justify-center"
                    style={{
                      cursor: data.special_note ? "pointer" : "default",
                    }}
                  >
                    {data.special_note ? "Special Note" : "-"}
                  </span>
                </Tooltip>

                {/* Vehicle note with HTML tooltip */}
                {data.vehicle_note && data.vehicle_note.trim() !== "" && (
                  <Tooltip
                    title={
                      <span
                        dangerouslySetInnerHTML={{ __html: data.vehicle_note }}
                      />
                    }
                  >
                    <div
                      className="text-sm flex justify-center mt-1 text-gray-600"
                      style={{ cursor: "pointer" }}
                    >
                      Vehicle note
                    </div>
                  </Tooltip>
                )}
              </TableCell>

              <TableCell className="text-sm text-center">
                <span>{data.no_of_days}</span>
              </TableCell>
              <TableCell className="text-sm text-center">
                <span>{data.client_vehicle_name}</span>
              </TableCell>
              {!isTrans && (
                <TableCell className="text-sm text-center">
                  <span>{Math.round(Number(data.selling_price))}</span>
                </TableCell>
              )}
              <TableCell className="text-sm text-center">
                <Tooltip title={data.seller_mobile || "No mobile"} arrow>
                  <span>{data.seller}</span>
                </Tooltip>
              </TableCell>
              {showSensitiveColumns && (
                <TableCell>
                  <div className="flex items-center justify-center">
                    {data["arrival_executive"] === " " ||
                    !data["arrival_executive"] ? (
                      <span
                        className="text-red-500"
                        layout="outline"
                        onClick={() => {
                          setshowTourModal(true);
                          setclientid(data["client_id"]);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        Assign
                      </span>
                    ) : (
                      <div className="flex flex-col items-start items-center pt-4">
                        <span className="text-sm">
                          {data["arrival_executive"]}
                        </span>
                        <button
                          onClick={() => {
                            setshowTourModal(true);
                            setclientid(data["client_id"]);
                          }}
                          className="cursor-pointer text-blue-700 hover:text-blue-500 dark:text-gray-400 dark:hover:text-gray-300 "
                          style={{ fontSize: "12px", paddingTop: "5px" }}
                        >
                          Change
                        </button>
                      </div>
                    )}
                  </div>
                </TableCell>
              )}

              {/* //commented dpature executive */}
              {/* <TableCell>
              <div className="flex items-center justify-center">
                {data["departure_executive"] === " " ||
                !data["departure_executive"] ? (
                  <span
                    className="text-red-500"
                    layout="outline"
                    onClick={() => {
                      setshowTourModal(true);
                      setclientid(data["client_id"]);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    Assign
                  </span>
                ) : (
                  <div className="flex flex-col items-start">
                    <span className="text-sm">{data["departure_executive"]}</span>
                    <button
                      onClick={() => {
                        setshowTourDepartureModal(true);
                        setclientid(data["client_id"]);
                      }}
                      className="p-2 cursor-pointer text-gray-400 hover:text-green-600 focus:outline-none mt-2"
                      style={{ cursor: "pointer" }}
                    >
                      <Tooltips
                        id="edit"
                        Icon={FiEdit}
                        title="Edit"
                        bgColor="#10B981"
                      />
                    </button>
                  </div>
                )}
              </div>
            </TableCell> */}
              <TableCell className="text-center">
                <span className="text-sm">{data.vendor_name || "-"}</span>
              </TableCell>

              <TableCell className="text-center">
                <span className="text-sm">{data.franchise_name || "-"}</span>
              </TableCell>

              <TableCell>
                {data?.vehicles && data.vehicles.length > 0 ? (
                  (() => {
                    const current = data.vehicles.find(
                      (v) => v.type === "current",
                    );
                    const history = data.vehicles.filter(
                      (v) => v.type === "history",
                    );

                    return (
                      <div className="flex flex-col gap-1 text-sm">
                        {/* {history.length > 0 && (
                          <span
                            className="text-red-500 font-semibold cursor-pointer text-center "
                            onClick={() => {
                              setHistoryDrivers(history); // Store in state
                              setOpenDriverHistoryModal(true); // Open modal
                            }}
                          >
                            History
                          </span>
                        )} */}

                        {current?.driver_name ? (
                          <div className="flex flex-col text-center pt-2 text-sm ">
                            <Tooltip
                              title={
                                <div>
                                  <div className="pb-2">
                                    Driver No:{" "}
                                    {current.driver_no?.trim() || "N/A"}
                                  </div>
                                  <div className="pb-2">
                                    Vehicle No:
                                    {current.vehicle_reg_no?.trim() || "N/A"}
                                  </div>
                                  <div className="pb-2">
                                    Vehicle Name:
                                    {current.vehicle_name?.trim() || "N/A"}
                                  </div>
                                </div>
                              }
                              placement="top"
                              color="#2f4050" // Dark background color
                              overlayStyle={{ fontSize: "12px" }} // Small font size
                            >
                              <div className="flex flex-col cursor-pointer ">
                                {current.driver_name.charAt(0).toUpperCase() +
                                  current.driver_name.slice(1)}
                                {hideEdit && (
                                  <span
                                    className="px-3 cursor-pointer text-blue-700 hover:text-blue-500 dark:text-gray-400 dark:hover:text-gray-300 text-center pt-2"
                                    onClick={() => {
                                      setSelectedData(current);
                                      setOpenDriverModal(true);
                                    }}
                                  >
                                    SMS
                                  </span>
                                )}
                              </div>
                            </Tooltip>
                          </div>
                        ) : data.is_date_changed ? (
                          <span
                            className="text-center text-yellow-600 font-semibold"
                            title="Booking's city/dates were edited after allotment — waiting for re-allotment"
                          >
                            Edited – Awaiting Re-allotment
                          </span>
                        ) : (
                          <span className="text-center">-</span>
                        )}
                      </div>
                    );
                  })()
                ) : (
                  <div className="text-center">
                    <span>-</span>
                  </div>
                )}
              </TableCell>

              {/* <TableCell>
  {data?.vehicles && data.vehicles.length > 0 ? (() => {
    const current = data.vehicles.find(v => v.type === "current");
    const historyVehicles = data.vehicles.filter(v => v.type === "history");

    return (
      <div className="flex flex-col gap-1 text-sm">
        {historyVehicles.length > 0 && (
          <span
            className="text-red-500 font-semibold cursor-pointer underline"
            onClick={() => {
              setHistoryVehicles(historyVehicles); // Pass history vehicles to modal
              setOpenVehicleHistoryModal(true);
            }}
          >
            History
          </span>
        )}

        {current?.vehicle_name ? (
          <div
            className="flex flex-col"
            title={`Reg No: ${current.vehicle_reg_no?.trim() || "N/A"}`}
            style={{ color: "black" }}
          >
            {current.vehicle_name.charAt(0).toUpperCase() + current.vehicle_name.slice(1)}
            <div className="text-xs text-gray-600">
              Reg No: {current.vehicle_reg_no || "N/A"}
            </div>
          </div>
        ) : (
          <span>No current vehicle</span>
        )}
      </div>
    );
  })() : (
    <span>No vehicles found</span>
  )}
</TableCell> */}
              {showSensitiveColumns && (
                <TableCell>
                  <div className="flex flex-col row-gap-3 text-sm justify-center items-center">
                    {data.end_date < today && (
                      <span>
                        <Button onClick={() => handleDownload(data.client_id)}>
                          <FiDownload />
                        </Button>
                      </span>
                    )}
                    <span
                      className="cursor-pointer text-blue-700 hover:text-blue-500 dark:text-gray-400 dark:hover:text-gray-300 "
                      onClick={() => {
                        setSelectedData(data);
                        setShowModal(true);
                      }}
                    >
                      Send mail
                    </span>
                  </div>
                </TableCell>
              )}

              <TableCell className="text-center">
                <Tooltip className="text-center" title={data.vehicle_remark}>
                  <span className="text-sm text-center">
                    {data.vehicle_remark ? `Remark` : "-"}
                  </span>
                </Tooltip>
              </TableCell>

              {showSensitiveColumns && (
                <TableCell className="text-center">
                  <div className="text-center">
                    <span
                      onClick={() => {
                        if (isFeedbackFilled) {
                          setSelectedData(data);
                          setShowViewFeedbackModal(true); // open modal
                        }
                      }}
                      style={{
                        color: isFeedbackFilled ? "green" : "red",
                        cursor: isFeedbackFilled ? "pointer" : "default",
                      }}
                    >
                      {isFeedbackFilled ? "View" : "Not Updated"}
                    </span>
                  </div>
                  <div className="text-center">
                    <span
                      className="text-sm text-red-600 cursor-pointer inline-flex items-center gap-3"
                      onClick={() => {
                        setSelectedData(data);
                        SetEscalateModal(true);
                      }}
                    >
                      <span>Escalation</span>

                      {getEscalationStatus(data?.ontour_escalation) ===
                        "ongoing" && (
                        <Tooltip
                          title={
                            <div className="text-xs text-center">
                              <strong>Status:</strong> Ongoing
                            </div>
                          }
                          placement="top"
                          componentsProps={{
                            tooltip: {
                              sx: { fontSize: "12px", padding: "8px" },
                            },
                          }}
                        >
                          <span className="text-blue-500 cursor-pointer">
                            <FaInfoCircle />
                          </span>
                        </Tooltip>
                      )}
                      {getEscalationStatus(data?.ontour_escalation) ===
                        "sorted" && (
                        <span className="bg-gray-300 text-gray-700 rounded-full w-4 h-4 flex items-center justify-center text-xs font-semibold">
                          {getSortedCount(data?.ontour_escalation)}
                        </span>
                      )}
                    </span>
                  </div>
                  <div className="text-center">
                    <span
                      onClick={() => openHistoryModal(data.client_id)}
                      className="text-sm text-green-600 cursor-pointer inline-flex items-center gap-3"
                    >
                      View History
                    </span>
                  </div>
                </TableCell>
              )}

              {hideEdit &&
                (data.is_online === false ? (
                  <TableCell className="text-center">
                    <div className="flex flex-col items-center gap-2 text-sm">
                      {/* &&  data.end_date> currentdata */}
                      {data.status === 0 &&
                        parseDMY(data.end_date) >= todayDate && (
                          <span
                            className="text-red-500 cursor-pointer"
                            onClick={() => {
                              if (data.is_online) {
                                setShowCancelModal(true);
                                setBookingId(data.client_id);
                              } else {
                                const now = new Date();
                                const startDate = data.start_date
                                  ? (() => {
                                      const [day, month, year] =
                                        data.start_date.split("-");
                                      return new Date(
                                        `${year}-${month}-${day}`,
                                      );
                                    })()
                                  : null;
                                // console.log(startDate, now);
                                const isCancellationExceed = startDate
                                  ? now >= startDate
                                  : false;
                                setShowCancelOfflineModal(true);
                                setBookingId(data.client_id);
                                setSellingPrice(data.selling_price);
                                setCancellationExceed(isCancellationExceed);
                              }
                            }}
                          >
                            Cancel
                          </span>
                        )}
                      <span
                        className="text-gray-700 cursor-pointer"
                        title={`${data.cancel_reason}\nRefundable Amount: ${data?.refundable_amount}`}
                      >
                        {data.cancel_reason?.substring(0, 15)}...
                      </span>
                    </div>
                  </TableCell>
                ) : (
                  <TableCell className="text-center">
                    <div>
                      <span className="text-xs text-red-500">
                        {" "}
                        Cannot cancel online bookings
                      </span>
                    </div>
                  </TableCell>
                ))}

              {showSensitiveColumns && (
                <TableCell className="text-sm text-center cursor-pointer">
                  {data.is_client_not_arrived === null ||
                  data.is_client_not_arrived === true ||
                  data.is_client_not_arrived === "true" ? (
                    <span className="text-red-400">UnArrived</span>
                  ) : (
                    <span className="text-green-400">Arrived</span>
                  )}

                  <div className="text-blue-400 mt-1 space-x-4">
                    {data.is_client_not_arrived === null ||
                    data.is_client_not_arrived === true ? (
                      <span
                        onClick={() => {
                          setSelectedBooking(data?.is_driver_vehicle_alloted);
                          setshowUpdatearrivalModal(true);
                          setclientid(data["client_id"]);
                          setGuestImage(data["guest_image"]);

                          setActionLabels({
                            viewLabel: "",
                            editLabel: "",
                            actionLabel: "Action", // set action label here
                          });
                        }}
                        className=" cursor-pointer"
                      >
                        Action
                      </span>
                    ) : (
                      <>
                        <button
                          className=" text-blue-500 hover:text-blue-700"
                          onClick={() => {
                            setshowUpdatearrivalModal(true);
                            setclientid(data["client_id"]);
                            setGuestImage(data["guest_image"]);
                            setSelectedBooking(true);
                            setActionLabels({
                              viewLabel: "View",
                              editLabel: "",
                              actionLabel: "",
                            });
                          }}
                        >
                          View
                        </button>

                        {/* <button
                          className=" text-blue-500 hover:text-blue-700"
                          onClick={() => {
                            setshowUpdatearrivalModal(true);
                            setclientid(data["client_id"]);
                            setGuestImage(data["guest_image"]);
                            setSelectedBooking(data.is_driver_vehicle_alloted);
                            setActionLabels({
                              viewLabel: "",
                              editLabel: "Edit",
                              actionLabel: "",
                            });
                          }}
                        >
                          Edit
                        </button> */}
                      </>
                    )}
                  </div>
                </TableCell>
              )}

              {hideView && (
                <TableCell>
                  <div className="flex justify-end text-right">
                    <button
                      onClick={() =>
                        handleView(data.client_id, "Booking Details")
                      }
                      className="px-3 py-2 cursor-pointer text-gray-400 hover:text-red-600 focus:outline-none"
                    >
                      <FiEye />
                    </button>
                    {!data?.is_online && data.status === 0 && (
                      <EditDeleteButton
                        title={"Agents"}
                        id={data.client_id}
                        handleUpdate={handleUpdate}
                        handleModalOpen={handleModalOpen}
                        hideDelete={hideDelete}
                        hideEdit={hideEdit}
                      />
                    )}
                  </div>
                </TableCell>
              )}
            </TableRow>
          );
        })}
      </TableBody>
      <ItineraryModal
        isOpen={showItineraryModal}
        content={itinerary}
        onClose={() => setShowItineraryModal(false)}
      />
      <CancelModal
        isOpen={showCancelModal}
        id={bookingId}
        onClose={() => setShowCancelModal(false)}
        onConfirm={handleCancelBooking}
      />
      {showUpdatearrivalModal &&
        (selectedBooking ? (
          <Updatearrivalmodal
            isOpen={showUpdatearrivalModal}
            client_id={clientid}
            guest_image={guestimage}
            onClose={() => setshowUpdatearrivalModal(false)}
            viewLabel={actionLabels.viewLabel}
            editLabel={actionLabels.editLabel}
            actionLabel={actionLabels.actionLabel}
          />
        ) : (
          <BookingUpdatearrivalmodal
            isOpen={showUpdatearrivalModal}
            onClose={() => setshowUpdatearrivalModal(false)}
          />
        ))}

      <CancelOfflineModal
        isOpen={showCancelOfflineModal}
        id={bookingId}
        cancellationExceed={cancellationExceed}
        sellingPrice={sellingPrice}
        onClose={() => {
          setShowCancelOfflineModal(false);
          setCancellationExceed(false); // Reset state
        }}
        onConfirm={handleCancelOfficeBooking}
      />
      <Tourexecutemodal
        isOpen={showTourModal}
        id={serviceId}
        title={title}
        data={agents}
        client_id={clientid}
        onClose={() => setshowTourModal(false)}
      />
      <Modal
        open={openDriverHistoryModal}
        onCancel={() => setOpenDriverHistoryModal(false)}
        footer={null}
        title="Driver History"
      >
        <div className="flex flex-col gap-2">
          {historyDrivers.map((driver, index) => (
            <div
              key={index}
              className="p-2 rounded border shadow-sm bg-gray-50 dark:bg-gray-800"
            >
              <div>
                <strong>Driver:</strong> {driver.driver_name}
              </div>
              <div>
                <strong>Contact:</strong> {driver.driver_no || "N/A"}
              </div>
              <div>
                <strong>Vehicle:</strong> {driver.vehicle_name}
              </div>
              <div>
                <strong>Reg No:</strong> {driver.vehicle_reg_no || "N/A"}
              </div>
              <div>
                <strong>Vendor Name:</strong> {driver.vendor_name || "N/A"}
              </div>
              {/* <div><strong>Changed Date:</strong> {driver.changed_date || "N/A"}</div> */}
              <div>
                <strong>Remark:</strong> {driver.remark || "N/A"}
              </div>
            </div>
          ))}
        </div>
      </Modal>
      <Modal
        open={openDriverHistoryModal}
        onCancel={() => setOpenDriverHistoryModal(false)}
        footer={null}
        title="Driver History"
      >
        <div className="flex flex-col gap-2">
          {historyDrivers.map((driver, index) => (
            <div
              key={index}
              className="p-2 rounded border shadow-sm bg-gray-50 dark:bg-gray-800"
            >
              <div>
                <strong>Driver:</strong> {driver.driver_name}
              </div>
              <div>
                <strong>Contact:</strong> {driver.driver_no || "N/A"}
              </div>
              <div>
                <strong>Vehicle:</strong> {driver.vehicle_name}
              </div>
              <div>
                <strong>Reg No:</strong> {driver.vehicle_reg_no || "N/A"}
              </div>
              <div>
                <strong>Vendor Name:</strong> {driver.vendor_name || "N/A"}
              </div>
              {/* <div><strong>Changed Date:</strong> {driver.changed_date || "N/A"}</div> */}
              <div>
                <strong>Remark:</strong> {driver.remark || "N/A"}
              </div>
            </div>
          ))}
        </div>
      </Modal>
      {/* <Modal
  open={openVehicleHistoryModal}
  onCancel={() => setOpenVehicleHistoryModal(false)}
  footer={null}
  title="Vehicle History"
>
  <div className="flex flex-col gap-2">
    {historyVehicles.map((vehicle, index) => (
      <div
        key={index}
        className="p-2 rounded border shadow-sm bg-gray-50 dark:bg-gray-800"
      >
        <div><strong>Vehicle:</strong> {vehicle.vehicle_name}</div>
        <div><strong>Reg No:</strong> {vehicle.vehicle_reg_no || "N/A"}</div>
      </div>
    ))}
  </div>
</Modal> */}

      <TourDepatureexecutemodal
        isOpen={showTourDepartureModal}
        id={serviceId}
        title={title}
        data={agents}
        client_id={clientid}
        onClose={() => setshowTourDepartureModal(false)}
      />
    </>
  );
};

export default BookingsTable;
